import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import ActionIndicatorIcon from './action_indicator_icon.jsx';

import { 
  TILE_ACTION_INDICATOR_DEFAULT
} from 'zoomforth_codesbane_viewer/const/tile_actions.js';


class GridTileActionIndicator extends Component {
  
  render() {
    
    const {
      topOffsetStyle,
      leftOffsetStyle,
      indicatorType,
      indicatorIcon,
      asset
    } = this.props;

    const isDisplayableAsOther = indicatorType == 'other' || indicatorType == 'ppt';

    const indicatorTypeClassName = (
      isDisplayableAsOther ?
        'indicator-type-other'
      :
        `indicator-type-${indicatorType}`
    );

    return (
      <div 
        className={classNames('tile-action-indicator-container', indicatorTypeClassName)}
        style={{
          top: topOffsetStyle,
          left: leftOffsetStyle
        }}
      >
        {
          indicatorType === 'ppt' ?
            'Presentation'

          : indicatorType === 'other' ?
            asset.extension

          :
            <div className="tile-action-icon-wrapper">
              <ActionIndicatorIcon
                indicatorType={
                  indicatorIcon ?
                    indicatorIcon.type === TILE_ACTION_INDICATOR_DEFAULT ?
                      indicatorType
                    :
                      indicatorIcon
                  :
                    indicatorType
                }
              />
            </div>
        }
      </div>
      
    );
  }
}


GridTileActionIndicator.propTypes = {
  indicatorIcon: PropTypes.object.isRequired,
  indicatorType: PropTypes.string.isRequired,
  topOffsetStyle: PropTypes.string.isRequired,
  leftOffsetStyle: PropTypes.string.isRequired
};

export default GridTileActionIndicator;
